
export default (urlParameters) => {
  return {
    ads_allowed: true,
    complete_report_map: true,
    show_widgets: true,
    platform: 'web'
  }
}